module.exports = __webpack_public_path__ + "static/media/featured_listing_3.20545dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/LandingPage/images/featured_listing_3.jpg
// module id = 2319
// module chunks = 0